/* eslint-disable react-hooks/rules-of-hooks */
import { useShallow } from 'zustand/shallow';

import { useDcrNavigationStore } from './dcrNavigationStore';

// Getters
export const getDcrNavSections = () =>
	useDcrNavigationStore(state => state.sections);

// Setters
export const useDcrNavSection = () =>
	useDcrNavigationStore(
		useShallow(({ addSection, setHidden, removeSection }) => ({
			addSection,
			setHidden,
			removeSection
		}))
	);
